export * from './UiFrameSizeMinIcon';
export * from './UiFrameSizeMinIcon16Light';
export * from './UiFrameSizeMinIcon16Regular';
export * from './UiFrameSizeMinIcon16Solid';
export * from './UiFrameSizeMinIcon20Light';
export * from './UiFrameSizeMinIcon20Regular';
export * from './UiFrameSizeMinIcon20Solid';
export * from './UiFrameSizeMinIcon24Regular';
export * from './UiFrameSizeMinIcon24Solid';
export * from './UiFrameSizeMinIcon32Regular';
export * from './UiFrameSizeMinIcon64Regular';
